"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataBundleRoutes = void 0;
const route_1 = require("../route");
class DataBundleRoutes extends route_1.Route {
    constructor() {
        super('data_bundles');
    }
    getOptions({ phoneNumber, carrier }) {
        return this.get('/options', { phoneNumber, carrier });
    }
    purchase({ phoneNumber, optionId, contactName = null }) {
        return this.post('/purchase', { phoneNumber, optionId, contactName });
    }
}
exports.DataBundleRoutes = DataBundleRoutes;
//# sourceMappingURL=data_bundles.js.map